import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import WhereDoYouLive from '../../steps/WhereDoYouLive';
import { OnboardingNode } from '../../types';

export const JURISDICTION_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.JURISDICTION,
  options: { countsTowardProgressBar: true },
  elements: [
    {
      uid: OnboardingStepType.JURISDICTION,
      component: (
        <WhereDoYouLive
          uid={OnboardingStepType.JURISDICTION}
          nodeType={OnboardingNodeType.JURISDICTION}
          displayName="Location & Insurance Info"
          actionButtonText="Continue"
        />
      )
    }
  ]
};
